import { apiClient } from './client';

export type AiGenStatus = 'PENDING' | 'PROCESSING' | 'READY' | 'FAILED';

export interface CameraPresetDTO {
  id: string;
  label: string;
  category: 'zoom' | 'move' | 'orbit' | 'aerial' | 'style' | 'static';
  hint: string;
  costSwipa: number;
}

/** Видео-движок: длительности + честная цена за каждую (источник — backend models.ts). */
export interface VideoModelDTO {
  id: string;
  label: string;
  hint: string;
  durations: number[];
  defaultDuration: number;
  /** Движок умеет только image-to-video — нужен стартовый кадр. */
  requiresImage: boolean;
  /** длительность(сек) → цена в SWIPA */
  prices: Record<number, number>;
}

export interface AiGenJob {
  id: string;
  status: AiGenStatus;
  engine: string;
  durationSec: number | null;
  presetId: string;
  prompt: string;
  aspectRatio: '9:16' | '16:9' | '1:1';
  costSwipa: number;
  error: string | null;
  resultMediaId: string | null;
  draftId: string | null;
  refunded: boolean;
  createdAt: string;
  completedAt: string | null;
}

export interface AiVideoQuota {
  used: number;
  limit: number;
  remaining: number;
}

export const aiVideoApi = {
  async presets() {
    const r = await apiClient.get('/api/ai-video/presets');
    return r.data.presets as CameraPresetDTO[];
  },
  async models() {
    const r = await apiClient.get('/api/ai-video/models');
    return r.data.models as VideoModelDTO[];
  },
  async quota() {
    const r = await apiClient.get('/api/ai-video/quota');
    return r.data as AiVideoQuota;
  },
  async create(body: {
    prompt: string;
    presetId: string;
    aspectRatio?: '9:16' | '16:9' | '1:1';
    modelId?: string;
    durationSec?: number;
    sourceMediaId?: string;
    /** Клиентский jobId (ref=gen:<jobId>) + txHash подписанной оплаты. */
    jobId: string;
    txHash: string;
  }) {
    const r = await apiClient.post('/api/ai-video', body);
    return r.data.job as AiGenJob;
  },
  async get(id: string) {
    const r = await apiClient.get(`/api/ai-video/${id}`);
    return r.data.job as AiGenJob;
  },
};
